import { defineAsyncComponent } from "vue"

export function registerGlobalComponents(app) {
    app.component('LanguageSwitcher', defineAsyncComponent(() => import('./LanguageSwitcher.vue')));
    app.component('FlashMessages', defineAsyncComponent(() => import('./FlashMessages.vue')));
    app.component('Icon', defineAsyncComponent(() => import('./Icon.vue')));
    app.component('Avatar', defineAsyncComponent(() => import('./Avatar.vue')));
    app.component('Dropdown', defineAsyncComponent(() => import('./Dropdown.vue')));
    app.component('Breadcrumb', defineAsyncComponent(() => import('./Breadcrumb.vue')));
    app.component('WaspitoInput', defineAsyncComponent(() => import('./WaspitoInput.vue')));
    app.component('WaspitoTelInput', defineAsyncComponent(() => import('./WaspitoTelInput.vue')));
    app.component('WaspitoFileInput', defineAsyncComponent(() => import('./WaspitoFileInput.vue')));
    app.component('Accordion', defineAsyncComponent(() => import('./Accordion.vue')));
    app.component('SliderLayout', defineAsyncComponent(() => import('./SliderLayout.vue')));
    app.component('WaspitoLabel', defineAsyncComponent(() => import('./WaspitoLabel.vue')));
    app.component('WaspitoButton', defineAsyncComponent(() => import('./WaspitoButton.vue')));
    app.component('WaspitoPagination', defineAsyncComponent(() => import('./WaspitoPagination.vue')));
    app.component('OtpCodeInput', defineAsyncComponent(() => import('./OtpCodeInput.vue')));
    app.component('FormError', defineAsyncComponent(() => import('./FormError.vue')));
    app.component("data-table", defineAsyncComponent(() => import('./DataTable/DataTable.vue')));
    app.component("data-table-cell", defineAsyncComponent(() => import('./DataTable/DataTableCell.vue')));
    app.component("ReadMore", defineAsyncComponent(() => import('./ReadMore.vue'))); 
    app.component("multiselect", defineAsyncComponent(() => import('./MultiSelect/Multiselect.vue')));
}





